// extracted by mini-css-extract-plugin
module.exports = {"form":"recordOfAdverseReactions_form__3du56","content":"recordOfAdverseReactions_content__Lbi-9","contentMain":"recordOfAdverseReactions_contentMain__2bAS7"};